(() => {
  const valid = color => /^#[\da-f]{6}$/i.test(color || '');
  const luminance = hex => {
    const channels = [1, 3, 5].map(i => parseInt(hex.slice(i, i + 2), 16) / 255).map(s => s <= 0.04045 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4);
    return channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722;
  };
  const ratio = (a, b) => {
    if (!valid(a) || !valid(b)) return null;
    const x = luminance(a), y = luminance(b);
    return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05);
  };
  const update = (palette, { backgrounds, color, size = 0, weight = 400, sampled = false } = {}) => {
    if (!palette) return;
    const labels = JSON.parse(palette.closest('[data-bb-color-advice]')?.dataset.bbColorAdvice || '{}');
    const large = size >= 24 || (weight >= 700 && size >= 18.6666667);
    const threshold = large ? 3 : 4.5;
    const surfaces = [...new Set((backgrounds || []).filter(valid))];
    const score = hex => surfaces.length ? Math.min(...surfaces.map(bg => ratio(hex, bg))) : null;
    const buttons = [...palette.querySelectorAll('button[data-color-hex]')];
    const ranked = buttons.map((button, i) => {
      button.dataset.paletteOrder ??= String(i);
      const contrast = score(button.dataset.colorHex);
      const group = contrast === null ? 3 : contrast >= 4.5 ? 0 : large && contrast >= 3 ? 1 : 2;
      const recommended = group === 0;
      button.dataset.contrast = contrast === null ? '' : contrast.toFixed(3);
      button.dataset.recommended = String(recommended);
      let badge = button.querySelector('[data-color-recommendation]');
      if (!badge) { badge = document.createElement('small'); badge.dataset.colorRecommendation = ''; badge.className = 'bb-color-recommendation'; button.append(badge); }
      badge.textContent = labels.recommended || '';
      badge.hidden = !recommended;
      return { button, contrast, group, order: Number(button.dataset.paletteOrder) };
    }).sort((a, b) => a.group - b.group || (b.contrast || 0) - (a.contrast || 0) || a.order - b.order);
    if (ranked.some((entry, i) => buttons[i] !== entry.button)) {
      const focus = document.activeElement;
      const keepFocus = palette.contains(focus);
      ranked.forEach(entry => palette.append(entry.button));
      if (keepFocus) focus.focus({ preventScroll: true });
    }
    let hint = palette.parentElement.querySelector('[data-color-contrast-hint]');
    if (!hint) { hint = document.createElement('p'); hint.className = 'bb-color-contrast-hint'; hint.dataset.colorContrastHint = ''; hint.setAttribute('role', 'status'); hint.setAttribute('aria-live', 'polite'); palette.after(hint); }
    const contrast = score(color);
    hint.textContent = contrast !== null && contrast < threshold ? labels.low : sampled ? labels.photo : surfaces.length ? '' : labels.unknown;
    hint.hidden = !hint.textContent;
    palette.dataset.contrastThreshold = String(threshold);
  };
  const sample = (context, rect) => {
    const colors = [];
    try {
      const width = context.canvas.width, height = context.canvas.height;
      for (let row = 0; row < 7; row++) for (let col = 0; col < 9; col++) {
        const x = Math.max(0, Math.min(width - 1, Math.round(rect.x + rect.w * (col + .5) / 9)));
        const y = Math.max(0, Math.min(height - 1, Math.round(rect.y + rect.h * (row + .5) / 7)));
        const pixel = context.getImageData(x, y, 1, 1).data;
        if (pixel[3] === 255) colors.push('#' + [...pixel].slice(0, 3).map(v => v.toString(16).padStart(2, '0')).join(''));
      }
    } catch { return []; }
    return [...new Set(colors)];
  };
  window.BBColorAdvice = { ratio, update, sample };
})();
